import { z } from "zod";

export const createOrganizationSchema = z.object({
  name: z.string().min(1, "Organization name is required"),
  legalName: z.string().min(1, "Legal name is required"),
  companyAddress: z.string().min(1, "Address is required"),
  taxId: z.string().min(1, "Tax ID is required"),
  industry: z.string().min(1, "Please select an industry"),
});

export type CreateOrganizationFormValues = z.infer<typeof createOrganizationSchema>;
